import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { DirectivesModule } from './directives/directives.module';
import { SharedModule } from '@components/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { LoaderQuestionsComponent } from '@components/modals/loader-questions/loader-questions.component';

@NgModule( {
  declarations: [
    AppComponent,
    LoaderQuestionsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    DirectivesModule,
    SharedModule,
    ReactiveFormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
} )
export class AppModule {}
